import axios from 'axios';
import { router } from '@inertiajs/react';
import { initializeCsrfProtection } from './utils/form-csrf-migration';
import { configureAxios, appConfig, debugLog, redirectTo } from './config/app-config';

// Configure axios
window.axios = axios;

// Configuration automatique de l'URL selon l'environnement
configureAxios();

debugLog('Application started', {
    config: appConfig,
    currentUrl: window.location.href
});

// Configure Inertia avec gestion d'erreurs améliorée
router.on('before', (event) => {
    // Refresh CSRF token before each request
    const token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
        debugLog('CSRF token refreshed from meta tag');
    }
});

router.on('success', (event) => {
    debugLog('Router success:', event);
});

router.on('error', (errors) => {
    debugLog('Router error:', errors);

    // Handle CSRF token mismatch errors (419)
    if (errors.response && errors.response.status === 419) {
        console.warn('[Router] CSRF token expired, refreshing page');
        setTimeout(() => {
            window.location.reload();
        }, 500);
        return;
    }

    // Handle other session-related errors
    if (errors.response && errors.response.status === 401) {
        console.warn('[Router] Session expired, redirecting to login');
        redirectTo('/login');
        return;
    }

    // Handle 404 errors - might be due to wrong base URL
    if (errors.response && errors.response.status === 404) {
        console.warn('[Router] 404 error detected:', {
            url: errors.config?.url || 'Unknown URL',
            fullUrl: errors.request?.responseURL || 'Unknown',
            method: errors.config?.method || 'Unknown'
        });
    }
});

// Add CSRF Token to all requests
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    debugLog('Initial CSRF token set');
} else {
    console.error('CSRF token not found in meta tag');
}

// Interceptor to handle expired sessions with better error handling
axios.interceptors.response.use(
    (response) => {
        debugLog('Axios response success:', response.config.url);
        return response;
    },
    async (error) => {
        debugLog('Axios response error:', {
            status: error.response?.status,
            url: error.config?.url,
            method: error.config?.method
        });

        if (error.response?.status === 419) {
            console.warn('[Axios] CSRF token expired, refreshing page');
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else if (error.response?.status === 401) {
            console.warn('[Axios] Session expired, redirecting to login');
            redirectTo('/login');
        } else if (error.response?.status === 404) {
            console.warn('[Axios] 404 error for URL:', {
                url: error.config?.url,
                fullUrl: error.request?.responseURL,
                baseURL: window.axios.defaults.baseURL
            });
        }

        return Promise.reject(error);
    }
);

// Initialize global CSRF protection for all forms
initializeCsrfProtection();

// Refresh CSRF token periodically with better error handling
setInterval(async () => {
    try {
        debugLog('Attempting to refresh CSRF token...');
        const response = await axios.get('/csrf-token');
        if (response.data.csrf_token) {
            // Update meta tag
            const metaTag = document.head.querySelector('meta[name="csrf-token"]');
            if (metaTag) {
                metaTag.setAttribute('content', response.data.csrf_token);
            }
            // Update axios headers
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf_token;
            debugLog('CSRF token refreshed successfully');
        }
    } catch (error) {
        console.error('[CSRF Protection] Failed to refresh token:', error);
        debugLog('CSRF refresh failed, but continuing...');
    }
}, appConfig.csrfRefreshInterval);
